<template>
    <el-dialog
        class="setMetafileds"
        :visible.sync="skuTempVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="800px"
        title="SKU Temp"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container" v-loading="loadingNum">
            <div ref="searchForm">
                <el-form
                    :model="searchForm"
                    :inline="true"
                    @submit.native.prevent
                >
                    <el-form-item label="SKU" size="small">
                        <el-input
                            v-model="searchForm.keyword"
                            maxlength="100"
                            placeholder="Place Input"
                            size="small"
                            clearable
                            @keyup.enter.native="skuTemp(1)"
                            @clear="skuTemp(1)"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item style="margin-left: 10px" size="small">
                        <el-button
                            type="primary"
                            icon="el-icon-search"
                            size="mini"
                            @click="skuTemp(1)"
                        >
                            {{ $i18n.locale == "zh" ? "查询" : "Search" }}
                        </el-button>
                    </el-form-item>
                    <el-form-item size="small">
                        <el-button
                            size="mini"
                            type="primary"
                            class="el-icon-plus"
                            @click="addItem"
                        >
                            {{ $i18n.locale == "zh" ? "新增" : "Add" }}
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
            <el-form ref="setForm" :model="setForm" @keydown.enter.native.prevent>
                <el-table
                    :data="setForm.tableData"
                    highlight-current-row
                    align="center"
                    height="600px"
                >
                    <el-table-column label="SKU 1" property="sku_1">
                        <template slot-scope="scope">
                            <el-form-item
                                size="mini"
                                v-if="scope.row.btnType == 'edit'"
                                label-width="0"
                                :rules="[{ required: true }]"
                                :prop="'tableData.' + scope.$index + '.sku'"
                            >
                                <el-input
                                    size="mini"
                                    v-model="scope.row.sku_1"
                                    placeholder="Place Input"
                                >
                                </el-input>
                            </el-form-item>
                            <div v-else>
                                {{ scope.row.sku_1 }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="SKU 2" property="sku">
                        <template slot-scope="scope">
                            <el-form-item
                                size="mini"
                                v-if="scope.row.btnType == 'edit'"
                                label-width="0"
                                :rules="[{ required: true }]"
                                :prop="'tableData.' + scope.$index + '.sku'"
                            >
                                <el-input
                                    size="mini"
                                    v-model="scope.row.sku"
                                    placeholder="Place Input"
                                >
                                </el-input>
                            </el-form-item>
                            <div v-else>
                                {{ scope.row.sku }}
                            </div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column
                        label="创建时间"
                        property="create_time"
                        align="left"
                    >
                    </el-table-column> -->
                    <el-table-column label="Operation" property="name" align="left">
                        <template slot-scope="scope">
                            <el-button
                                size="mini"
                                type="text"
                                class="el-icon-edit"
                                @click="editItem(scope)"
                                v-show="scope.row.btnType == 'detail'"
                            >
                                {{ $i18n.locale == "zh" ? "编辑" : "Edit" }}
                            </el-button>

                            <el-button
                                size="mini"
                                type="text"
                                class="icon-baocun iconfont_action"
                                @click="saveItem(scope)"
                                v-show="scope.row.btnType == 'edit'"
                            >
                                {{ $i18n.locale == "zh" ? "保存" : "Save" }}
                            </el-button>
                            <el-button
                                size="mini"
                                type="text"
                                class="el-icon-close"
                                @click="cancelItem(scope)"
                                v-show="scope.row.btnType == 'edit'"
                            >
                                {{ $i18n.locale == "zh" ? "取消" : "Cancel" }}
                            </el-button>

                            <el-popconfirm
                                title="Remove,Continue?"
                                :confirm-button-text="confirmButtonText"
                                :cancel-button-text="cancelButtonText"
                                icon="el-icon-info"
                                icon-color="red"
                                @confirm="deleteItem(scope)"
                            >
                                <el-button
                                    size="mini"
                                    slot="reference"
                                    type="text"
                                    class="el-icon-delete deleteBtn"
                                    v-show="scope.row.btnType == 'detail'"
                                >
                                {{ $i18n.locale == "zh" ? "删除" : "Delete" }}
                                </el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>
                <pagination
                    :paginationData="paginationData"
                    @paginationChange="paginationChange"
                    funcName="skuTemp"
                ></pagination>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="skuTempVisible = false"
                >{{ $i18n.locale == "zh" ? "关闭" : "Close" }}</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import pagination from "@/common/components/pagination";
export default {
    data() {
        return {
            setForm: {
                tableData: [],
            },
            searchForm: {
                keyword: "",
            },
            loadingNum: 0,
            emptyItem: {
                sku: "",
                sku_1: "",
                btnType: "edit",
            },
            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },
        };
    },
    props: {
        skuTempVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    components: {
        pagination: pagination,
    },
    methods: {
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.skuTemp();
        },
        closeDialog() {
            this.$emit("update:skuTempVisible", false);
        },
        skuTemp() {
            this.loadingNum++;
            cmofferApi
                .skuTemp({ ...this.searchForm, ...this.paginationData }, "get")
                .then((res) => {
                    if (res) {
                        this.setForm.tableData = res.data;
                        this.paginationData.total = res.total;
                        for (let i in this.setForm.tableData) {
                            this.$set(
                                this.setForm.tableData[i],
                                "btnType",
                                "detail"
                            );
                        }
                    }
                    this.loadingNum--;
                });
        },
        addItem() {
            this.$nextTick(() => {
                this.setForm.tableData.unshift(
                    JSON.parse(JSON.stringify(this.emptyItem))
                );
            });
        },
        editItem(scope) {
            this.$refs.setForm.validate((valid) => {
                if (valid) {
                    for (let i in this.setForm.tableData) {
                        this.setForm.tableData[i].btnType = "detail";
                    }
                    scope.row.btnType = "edit";
                }
            });
        },
        saveItem(scope) {
            this.$refs.setForm.validate((valid) => {
                if (valid) {
                    this.loadingNum++;
                    if (scope.row.id) {
                        cmofferApi
                            .skuTemp({ ...scope.row }, "put", scope.row.id)
                            .then((res) => {
                                if (res) {
                                    this.$message.success(`${ this.$i18n.locale == "zh" ? "成功" : "Success" }`);
                                    this.skuTemp();
                                }
                                this.loadingNum--;
                            });
                    } else {
                        cmofferApi
                            .skuTemp({ ...scope.row }, "post")
                            .then((res) => {
                                if (res) {
                                    this.$message.success(`${ this.$i18n.locale == "zh" ? "成功" : "Success" }`);
                                    this.skuTemp();
                                }
                                this.loadingNum--;
                            });
                    }
                }
            });
        },
        deleteItem(scope) {
            this.loadingNum++;
            cmofferApi.skuTemp({}, "delete", scope.row.id).then((res) => {
                if (res) {
                    this.skuTemp();
                }
                this.loadingNum--;
            });
        },
        cancelItem(scope) {
            if (scope.row.id) {
                this.$refs.setForm.validate((valid) => {
                    if (valid) {
                        scope.row.btnType = "detail";
                    }
                });
            } else {
                this.setForm.tableData.splice(scope.$index, 1);
            }
        },
    },
    watch: {
        skuTempVisible: {
            handler(newValue) {
                if (newValue) {
                    this.skuTemp();
                }
            },
        },
    },
};
</script>
<style lang="scss">
.setMetafileds {
    .container {
        .el-button--text{
            margin-right: 5px;
        }
    }
}
</style>